// src/infrastructure/store/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";

// VN-08 / CA-03: se quitó redux-persist. authSlice ya restaura la sesión
// desde localStorage por su cuenta (loadInitialState), así que la copia
// duplicada que redux-persist guardaba en "persist:authToken" era una
// segunda fuente de verdad redundante y ya no existe.
const rootReducer = combineReducers({
  authToken: authReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});
